/**
 * @generated SignedSource<<34686976ee60b5a6e330e0be0c15c959>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateAssetFormFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateAssetFormFieldsFragment">;
  readonly " $fragmentType": "UpdateAssetFormFragment";
};
export type UpdateAssetFormFragment$key = {
  readonly " $data"?: UpdateAssetFormFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateAssetFormFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateAssetFormFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateAssetFormFieldsFragment"
    }
  ],
  "type": "Asset",
  "abstractKey": null
};

(node as any).hash = "9a2ef21c6d989c093747090f9dd09bca";

export default node;
